import React, { useState } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import country from "./country.json";
import { Multiselect } from "multiselect-react-dropdown"; 
import country_currency from "./country_currency.json";
import languageJson from './lanuages.json';

function Organization() {
  const [copied, setCopied] = React.useState(false);
  const [isTrueImage, setIsTrueIMg] = React.useState(false);  
  const [isTrueOfferUrl, setIsTrueOfferUrl] = React.useState([{status:'false', index: 0 }]);
  const [stateData, setStateData]= useState([]);
  const [inputFieldsEv1, setInputFieldsEv1] = useState({
    type: "ListItem",
    name: '',
    alternate_name:'',
    url:'',
    logourl:'',
    organization_type:'Organization',

  })
  const [inputFieldsEv, setInputFieldsEv] = useState([])

  const sportsData = [
    { id: 'Facebook', name: 'Facebook' },
    { id: 'Twitter', name: 'Twitter' },
    { id: 'Instagram', name: 'Instagram' },
    { id: 'YouTube', name: 'YouTube' },
    { id: 'LinkedIn', name: 'LinkedIn' },
    { id: 'Pinterest', name: 'Pinterest' },
    { id: 'SoundCloud', name: 'SoundCloud' },
    { id: 'Tumblr', name: 'Tumblr' },
    { id: 'Wikipedia', name: 'Wikipedia' },
    { id: 'Github', name: 'Github' },
    { id: 'Website', name: 'Website' }
  ];
  
  const [inputFieldsJp9, setInputFieldsJp9] = useState([])
  const [selectedVal, setSelectedVal] = useState([{}]);   
  const [AreasArr, setAreasArr] = useState([{}]);
  const [LanguagesArr, setLanguagesArr] = useState([{}]);
  const [OptionsArr, setOptionsArr] = useState([{}]);

  const handleChange8 = (newState = {}) => {
    const tempState = { ...selectedVal, ...newState };
    setSelectedVal(tempState); 
  };
  
  const handleChange9 = (event) => { 
    let value = event.target.value;
    let name = event.target.name;
    setInputFieldsJp9((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
  }
  const handleChange4 = (newState = {}) => {  
    setInputFieldsJp9(newState);
    setSelectedVal(newState);
  }; 
  

  /** Options Array value Start */
  const handleChangeOptions = (index, event) =>{
    const tempares = { ...OptionsArr, [index]:event };
    setOptionsArr(tempares); 
  }
  const handleRemoveOptions = (newState = {}, ind) =>{
    const tempOptionsState = { ...OptionsArr, [ind]:newState };
    setOptionsArr(tempOptionsState);
  }
  /** Options Array value End */

  /** Language Array value Start */
  const handleChangeLanguage = (index, event) =>{
    const tempares = { ...LanguagesArr, [index]:event };
    setLanguagesArr(tempares); 
  }
  const handleRemoveLanguage = (newState = {}, ind) =>{
    const tempLanguageState = { ...LanguagesArr, [ind]:newState };
    setLanguagesArr(tempLanguageState);
  }
  /** Language Array value End */
  
  /** Area Array value Start */
  const handleChangeArea = (index, event) =>{
    const tempares = { ...AreasArr, [index]:event };
    setAreasArr(tempares);  
  }
  const handleRemoveArea = (newState = {}, ind) =>{
    const tempAreaState = { ...AreasArr, [ind]:newState };
    setAreasArr(tempAreaState);
  }
  /** Area Array value End */

  const urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };
  const handleChange5 = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if(name === 'image'){
      let isTrueImage = !value || urlPatternValidation(value);
      if(isTrueImage === false)
      {
        setIsTrueIMg(true);
      }
      else{
        setIsTrueIMg(false);
      }
    }
    setInputFieldsEv1((prevalue) => {
      return {
        ...prevalue,   // Spread Operator              
        [name]: value
      }
    }) 
    if(name=== 'organization_type')
    {
      country_currency.countries.organizationType.map(function(item, i){
        if(item.id === value)
        {
          setStateData((prevState) => ({
            ...prevState,
            data: item.moreType
          }));
        }
       return item;
      })
    }
  }
  const handleChange2 = (indexs, evnt) => {
    const { name, value } = evnt.target;
    //isTrueOfferUrl
    if(name === 'offerurl'){
      let isTrueOfferUrl = !value || urlPatternValidation(value);
      if(isTrueOfferUrl === false)
      {
        setIsTrueOfferUrl({status:true, index:indexs});
      }
      else{
        setIsTrueOfferUrl({status:false, index:indexs});
      }
    }
    const list = [...inputFieldsEv];
    list[indexs][name] = value;
    setInputFieldsEv(list);
  } 
  function MyButton(props) {
    return <button {...props} />
  }    
  const addInputFieldEv = () => {
    setInputFieldsEv([...inputFieldsEv, {
      offername: '',
      type:'',
      phone: ''
    }]) 
  }
  const removeInputFieldsEv = (index) => {
    const rows = [...inputFieldsEv];
    rows.splice(index, 1);
    setInputFieldsEv(rows);
  } 
  
  const onCopy = React.useCallback(() => {
    setCopied(true);
    setTimeout(function(){
      setCopied(false);  
    },3000);
  }, [])
   
  const arrServ = (index) =>{
    let arryAres = [];
    if(AreasArr[index] !== undefined){
      Object.values(AreasArr[index]).map((item)=>{
        if(item.name !== undefined){
          arryAres.push('"'+item.name+'"');
        }
      });
    }
    return arryAres;
  }
  const arrOptions = (index) =>{
    let arryAres = [];
    if(OptionsArr[index] !== undefined){
      Object.values(OptionsArr[index]).map((item)=>{
        if(item.name !== undefined){
          arryAres.push('"'+item.name+'"');
        }
      });
    }
    return arryAres;
  }
  const arrLangeuage = (index) =>{
    let arryAres = [];
    if(LanguagesArr[index] !== undefined){
      Object.values(LanguagesArr[index]).map((item)=>{
        if(item.name !== undefined){
          arryAres.push('"'+item.name+'"');
        }
      });
    }
    return arryAres;
  }
  const moreAddContactStep = inputFieldsEv.map((item, index) => 
        `{
                "@type": "ContactPoint",
                "telephone": `+item.phone+`,
                "contactType": "`+item.type+`",
                "contactOption": [`+ arrOptions(index) + `],
                "areaServed": [`+ arrServ(index) + `],
                "availableLanguage": [`+ arrLangeuage(index) + `]
            }`
    );
    console.log("OptionsArr===", OptionsArr)
    const arrcheck = (AreasArr[0] !== undefined)?AreasArr[0]:'"f"';
    const LanguagesArrcheck = (LanguagesArr[0].id !== undefined)?arrServ[0]:'"d"';
    const OptionsArrcheck = (OptionsArr[0].id !== undefined)?OptionsArr[0]:'"test"';
    const addContact =(inputFieldsEv.length ==1 )? `"contactPoint": {
            "@type": "ContactPoint",
            "telephone": `+inputFieldsEv[0].phone+`,
            "contactType": "`+inputFieldsEv[0].type+`",
            "contactOption": `+OptionsArrcheck+`,
            "areaServed": `+arrcheck+`,
            "availableLanguage": `+LanguagesArrcheck+`
          }`:(inputFieldsEv.length > 1 )? ` "contactPoint": [
            `+moreAddContactStep+`
          ],`:'';
  const sameAs = `"sameAs": [
            `+Object.values(inputFieldsJp9).map((items) =>
                      JSON.stringify(items)
            )+`
          ]`;
  const EvIsMyCopy = `<script type="application/ld+json">
  {
      "@context": "https://schema.org",
      "@type": "`+inputFieldsEv1.organization_type+`",
      "name": "`+inputFieldsEv1.name+`",
      "alternateName": "`+inputFieldsEv1.alternate_name+`",
      "url": "`+inputFieldsEv1.url+`",
      "logo": "`+inputFieldsEv1.logourl+`",
      `+addContact+`
      `+sameAs+`
  }
  </script><!--OrganizationList Code Generated by https://w3speedup.com/tools/schema-markup-generator/ -->`;
  const offerAvaiabilityJson = [
    {"id":"TollFree","name":"Toll Free"},
    {"id":"HearingImpairedSupported","name":"Hearing Impaired Supported"},
  ];
  
  const resetFun = () =>{
    const sws_rows = {
      type: "ListItem",
      name: '',
      alternate_name:'',
      url:'',
      logourl:'', 
      organization_type:'Organization',
  
    };
    setInputFieldsEv1(sws_rows); 
    setInputFieldsEv([{
      type: '',
      phone: ''
    }]);
    setSelectedVal([{}]);
    setAreasArr([{}]);
    setLanguagesArr([{}]);
    setOptionsArr([{}]);
  } 
  return (
    <div className='container-flude organization_class'> 
        <div className='row mt-5'>
          <div className='col-md-8 mb-5 border'>
            <div className='mt-2 mb-2'><b>Organization - Logo, Contacts, Social Profile</b> </div>
              <div className="row input_fields d-flex">
                <div className="col-6">
                  <label>Organization @type</label>
                  <div className="form-group me-2 mb-2">
                    <select onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.organization_type} name="organization_type" className="form-control">
                      <option value="">
                        Please select Organization Type
                      </option>
                      {country_currency.countries.organizationType && country_currency.countries.organizationType.map((value, index)=>{
                          return (
                            <option key={index} value={value.id}> 
                              {value.name.length > 70 ?
                                `${value.name.substring(0, 70)}...` : value.name
                              }
                            </option>
                          )
                      })}
                    </select>
                  </div>
                </div>
                <div className="col-6">
                  <label>More specific @type</label>
                  <div className="form-group me-2 mb-2">
                    <select onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.more_type} name="more_type" className="form-control">
                      <option value="">
                        Please select Organization Type
                      </option>
                        {stateData.data && stateData.data.map((value, index)=>{
                          return(
                            <option key={index} value={value.id}>
                              {value.name}
                            </option>
                          )
                        })}
                    </select>
                  </div>
                </div>
                <div className="col-6">
                  <label>Name</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)}  value={inputFieldsEv1.name} name="name" className="form-control" placeholder="Name" />
                  </div>
                </div>
                <div className="col-6">
                  <label>Alternate name</label>
                  <div className="form-group me-2 mb-2">
                    <input type="text" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.alternate_name} name="alternate_name" className="form-control" placeholder="alternate_name" />
                  </div>
                </div>
                <div className="col-6">
                  <label>URL</label>
                  <div className="form-group me-2 mb-2">
                    <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.url} name="url" className="form-control" placeholder="URL" />
                  </div>
                </div>
                <div className="col-6">
                  <label>Logo URL</label>
                  <div className="form-group me-2 mb-2">
                    <input type="url" onChange={(evnt) => handleChange5(evnt)} value={inputFieldsEv1.logourl} name="logourl" className="form-control" placeholder="Logo URL" />
                  </div>
                </div>
                <div className="col-6">
                  <label>Social profiles</label>
                  <div className="form-group me-2 mb-2"> 
                    <Multiselect
                      options={sportsData}
                      name="unitText"
                      displayValue="name"
                      showCheckbox={true}
                      onRemove={(evnt) => handleChange4(evnt)}
                      onSelect={(evnt) => handleChange8(evnt)}
                    />
                  </div>
                </div>
                <div className='col-md-12'>   
                    { (Object.keys(selectedVal[0]).length> 0) && selectedVal &&  Object.values(selectedVal).map((data)=>{
                        let {name, id} = data; 
                        let valdata = (name==="Twitter")?inputFieldsJp9.Twitter:(name==="Twitter")?inputFieldsJp9.Twitter:(name==="Facebook")?inputFieldsJp9.Facebook:(name==="YouTube")?inputFieldsJp9.YouTube:(name==="Instagram")?inputFieldsJp9.Instagram:(name==="Tumblr")?inputFieldsJp9.Tumblr:
                        (name==="LinkedIn")?inputFieldsJp9.LinkedIn:(name==="Pinterest")?inputFieldsJp9.Pinterest:(name==="SoundCloud")?inputFieldsJp9.SoundCloud:(name==="Wikipedia")?inputFieldsJp9.Wikipedia:(name==="Github")?inputFieldsJp9.Github:(name==="Website")?inputFieldsJp9.Website:'';
                        return (
                          <div className="form-group me-2 mb-2" key={id}>
                            <input type="text" onChange={(evnt) => handleChange9(evnt)} value={valdata} name={name} className="form-control" placeholder={name} />
                          </div>
                        )
                      })
                    }
                </div>
                <hr/>
              </div>
              <div className="col mt-3 mb-3">
              <button className="btn btn-outline-success " onClick={addInputFieldEv}><i className="fa fa-plus"></i>   Add Contact</button>
            </div>
            { 
              inputFieldsEv.map((data, index) => {
                const { type,phone } = data;
                return (
                  <div className="row input_fields d-flex" key={index}> 
                      <div className="col-md-6 col-sm-12">
                        <label>Type</label>
                        <div className="form-group me-2 mb-2">
                          <select className='form-control' onChange={(evnt) => handleChange2(index, evnt)} value={type} name="type">
                              <option>
                                Select Availability
                              </option>
                                {country_currency.countries.type && country_currency.countries.type.map((value, index)=>{
                                    return (
                                      <option key={index} value={value.name}>
                                        {value.name}
                                      </option>
                                    )
                                })}
                            </select>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <label>Phone</label>
                        <div className="form-group me-2 mb-2">
                          <input type="text" onChange={(evnt) => handleChange2(index, evnt)} value={phone} name="phone" className="form-control" placeholder="Phone" />
                        </div>
                      </div>                     
                      <div className="col-md-6 col-sm-12">
                        <label>Area(s) served</label>
                        <div className="form-group me-2 mb-2"> 
                          <Multiselect
                            options={country.country}
                            name="area"
                            displayValue="name"
                            showCheckbox={true}
                            onRemove={(evnt) => handleRemoveArea(index,evnt)}
                            onSelect={(evnt) => handleChangeArea(index, evnt)}
                          />
                        </div>
                      </div>  
                      <div className="col-md-6 col-sm-12">
                        <label>Language(s)</label>
                        <div className="form-group me-2 mb-2">
                          <Multiselect
                            options={languageJson}
                            name="language"
                            displayValue="name"
                            showCheckbox={true}
                            onRemove={(evnt) => handleRemoveLanguage(index,evnt)}
                            onSelect={(evnt) => handleChangeLanguage(index, evnt)}
                          /> 
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <label>Options</label>
                        <div className="form-group me-2 mb-2">
                          <Multiselect
                            options={offerAvaiabilityJson}
                            name="offerAvaiability"
                            displayValue="name"
                            showCheckbox={true}
                            onRemove={(evnt) => handleRemoveOptions(index,evnt)}
                            onSelect={(evnt) => handleChangeOptions(index, evnt)}
                          /> 
                        </div>
                      </div>
                      <div className="col-2 text-center">
                        {(inputFieldsEv.length !== 1) ? <button className="btn btn-outline-danger" onClick={(evnt)=>removeInputFieldsEv(index, evnt)}>x</button> : ''}
                      </div> 
                    {(inputFieldsEv.length !== 1) ?<hr/>:''}
                  </div>
                )
              })
            }
            
          </div>
          <div className='col-md-4'>
            <div className="card">
              <div className="card-header d-flex">
                <CopyToClipboard onCopy={onCopy} text={EvIsMyCopy} >
                  <MyButton className="btn btn-success"><i className="fa-solid fa-copy"></i> Copy</MyButton>
                </CopyToClipboard>
                <MyButton className="btn btn-success" onClick={()=>resetFun()}><i className="fa-solid fa-arrows-rotate me-1"></i>Reset</MyButton>
              </div>
              <div className="card-body">
                {EvIsMyCopy}
              </div>
              {copied && 
                <div className="card-footer text-muted">
                  <div className="p-2 btn-success rounded">✅ copied successfully</div>
                </div>
              }
            </div>
          </div>
        </div> 
    </div>
  );
}

export default Organization